const attendanceStatusEnum = ['Applied', 'Approved', 'Rejected'];

const attendanceTypeEnum = ['Paid Leave', 'Unpaid Leave', 'Saturday Leave'];

const attendanceStatusOptions = attendanceStatusEnum.map((i) => {
  return {
    label: i,
    value: i
  };
});

export { attendanceStatusEnum, attendanceStatusOptions, attendanceTypeEnum };
